import React, { FC, useEffect } from 'react';
import LinearProgress from '@mui/material/LinearProgress';
import { styled } from '@mui/material/styles';

interface Props {
  duration: number;
  variant?: 'success' | 'info' | 'warning' | 'error';
  onClose?: () => void;
}

export const SnackbarProcess: FC<Props> = ({ duration, variant, onClose }) => {
  const [progress, setProgress] = React.useState(0);

  useEffect(() => {
    if (progress >= 100) {
      return;
    }

    const timer = setInterval(() => {
      if (progress >= 100) {
        if (onClose) onClose();
        return;
      }

      setProgress((oldProgress) => {
        if (+oldProgress >= 100) {
          return 100;
        }

        const elapsedProgress = (oldProgress * duration) / 100;
        return ((elapsedProgress + 500) * 100) / duration;
      });
    }, 500);

    return () => {
      clearInterval(timer);
    };
  }, []);

  return <StyledLinearProgress color={variant} variant="determinate" value={progress} />;
};

const StyledLinearProgress = styled(LinearProgress)(() => ({
  position: 'absolute',
  width: '100%',
  top: '-2px',
  left: '-1px',
  borderTopLeftRadius: '4px',
  borderTopRightRadius: '4px',
}));
